import React, { useEffect, useState } from "react";
import classes from './MaterialIssued.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Pencil, Trash2 } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import MaterialIssuedModal from "./MaterialIssuedModal";

const MaterialIssued = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [selectedMetrics, setSelectedMetrics] = useState({
        total_purchase: 0,
        outstanding: 0,
    });
    const [deliveredOrders, setDeliveredOrders] = useState([]);

    useEffect(() => {
        // Dummy data simulation (no API)
        setLoading(false);
        setSelectedMetrics({
            total_purchase: 120000,
            outstanding: 30000,
        });
        setDeliveredOrders([
            {
                id: 1,
                invoice_number: "INV-001",
                supplier: { name: "Supplier A" },
                quantity_supplied: 10,
                supplied_price: 500,
                supplied_amount: 5000,
                created_at: new Date(),
            },
            {
                id: 2,
                invoice_number: "INV-002",
                supplier: { name: "Supplier B" },
                quantity_supplied: 20,
                supplied_price: 400,
                supplied_amount: 8000,
                created_at: new Date(),
            },
        ]);
    }, []);

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };
    const [isModalOpen, setIsModalOpen] = useState(false);

    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === "") return "0.00";
        return new Intl.NumberFormat("en-NG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(value));
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.Container}>
                    <div className={classes.actions}>
                        <button
                            className={classes.btns}
                            onClick={() => navigate('/transactions/sales-invoice/sale')}
                        >
                            Sales Invoice
                        </button>
                        <button
                            className={classes.btns}
                            onClick={() => navigate('/Inventory/PurchaseOrder')}
                        >
                            Purchase Order
                        </button>
                        <button
                            className={`${classes.btns} ${isActive ? classes.active : ""}`}
                            onClick={() => setIsActive(true)}
                        >
                            Stock Delivery
                        </button>
                        <button
                            onClick={() => navigate('/settings/product-services')}
                            className={`${classes.btns} ${classes.greens}`}
                        >
                            Product & Services
                        </button>
                    </div>

                    <header className={classes.Header}>
                        <h2 className={classes.Title}>Raw Materials Issued</h2>
                    </header>

                    <div className={classes.entrjj}>
                        <div className={classes.allkads}>
                            <div className={classes.thrdkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Total sales</p>
                                    <p className={classes.kdptg1}>
                                        {selectedMetrics?.total_purchase?.toLocaleString() ?? '0'}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>This month</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.frtkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Outstanding</p>
                                    <p className={classes.kdptg2}>
                                        {selectedMetrics?.outstanding?.toLocaleString() ?? '0'}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Pending payments</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.fiftkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Overdue</p>
                                    <p className={classes.kdptg3}>0</p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Past due dates</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.frstkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>This month</p>
                                    <p className={classes.kdptg4}>15</p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Total invoices</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={classes.headerActions}>
                        <div className={classes.actionsRight}>
                            <div className={classes.inputWrapper}>
                                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                                <input type="text" className={classes.searchBar} placeholder="Search sales" />
                            </div>
                            <div className={classes.selectWrapper}>
                                <select className={classes.dropdown}>
                                    <option value="">All Status</option>
                                    <option value="Paid">Paid</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Overdue">Overdue</option>
                                    <option value="Draft">Draft</option>
                                </select>
                                <span className={classes.dropdownArrow}>▼</span>
                            </div>
                            <div className={classes.inputWrapper}>
                                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                                <img src={filter} alt="Filter" className={classes.inputIcon} />
                            </div>
                        </div>

                        <button
                            className={classes.btnss}
                            onClick={() => setIsModalOpen(true)}
                        >
                            + Materials to be Issued
                        </button>

                    </div>

                    <table className={classes.invoiceTable}>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Production Order No</th>
                                {/* <th>Supplier</th> */}
                                <th>Supplied Quantity</th>
                                <th>Supplied Price</th>
                                <th>Supplied Amount</th>
                                <th>Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center" }}>Loading...</td>
                                </tr>
                            ) : deliveredOrders.length > 0 ? (
                                deliveredOrders.map((row, index) => (
                                    <tr key={row.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{row.invoice_number}</td>
                                        {/* <td>{row.supplier?.name}</td> */}
                                        <td>{row.quantity_supplied}</td>
                                        <td style={{ textAlign: 'right' }}>
                                            {formatCurrency(row.supplied_price)}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            {formatCurrency(row.supplied_amount)}
                                        </td>
                                        <td>{new Date(row.created_at).toLocaleDateString()}</td>
                                        <td>
                                            <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                                                <Eye size={16} style={{ cursor: "pointer", color: "#007bff" }} />
                                                <Pencil size={16} style={{ cursor: "pointer", color: "#28a745" }} />
                                                <Trash2 size={16} style={{ cursor: "pointer", color: "#dc3545" }} />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center" }}>No records found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <MaterialIssuedModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />

            <Footer />
        </div>
    );
};

export default MaterialIssued;
